import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import PerfectScrollbar from 'react-perfect-scrollbar'

import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import DatePicker from 'material-ui-pickers/DatePicker';

import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import 'react-perfect-scrollbar/dist/css/styles.css';

import { contactsRef, eventsRef, childrenRef, imagesRef, auth, usersRef, invitesRef } from '../../firebase';

import moment from 'moment';
import { toast } from 'react-toastify';

import FileUploader from 'react-firebase-file-uploader';

const styles = theme => ({
    title: {
        paddingLeft: '2%',
        paddingRight: '5%',
        paddingTop: '2%',
        paddingBottom: '5rem',
    },
    close: {
        width: theme.spacing.unit * 4,
        height: theme.spacing.unit * 4,
    },
    root: {
        width: '100%',
        maxHeight: '160px',
        backgroundColor: theme.palette.background.paper,
        flexGrow: 1,
    },
  
  flex: {
    flexGrow: 1,
  },
});

class AddEvent extends Component {
    constructor(props) {
        super(props);

        const { id } = props.match.params;
        let mode = false;

        if (id) {
            mode = true;
        }

        this.state = { 
            pictures: [],
            kids: [],
            allKids: null,
            contacts: [],
            allContacts: null,
            date: moment(),
            description: '',
            location: '',
            state: '',
            street: '',
            zipCode: '',
            city: '',
            refId: this.props.myId,
            mode: mode,
            loading: mode,
            images: [],
            maxImages: false,
            saved: false,
            messageSection: false,
            subject: '',
            message: '',
            additionalGuest: '',
        };

        /* this.state.imageRefs.forEach(image => {
           imagesRef.child(image).getDownloadURL()
            .then(url => { 
                const { images } = this.state;

                images.push(url);

                this.setState({ images: images }); 
            });
        }) */

        this.onDrop = this.onDrop.bind(this);

        childrenRef.where('parentId', '==', this.props.myId).get()
            .then((querySnapshot) => {
                let allData = [];

                querySnapshot.forEach((doc) => {
                    
                    let data = doc.data();

                    let childData = {
                        id: doc.id,
                        name: data['firstName'] + ' ' + data['lastName'],
                        accountId: data['accountId'],
                    }

                    allData.push(childData);
                });

                this.setState({
                    allKids: allData,
                });
            });

        contactsRef.where('refId', '==', this.props.myId).get()
            .then((querySnapshot) => {
                let allData = [];

                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    let data = doc.data();

                    let contactData = {
                        id: doc.id,
                        name: data['firstName'] + ' ' + data['lastName'],
                        email: data['email'],
                    }

                    allData.push(contactData);
                });

                this.setState({
                    allContacts: allData,
                });
            });

        if (mode) {
            eventsRef.doc(id).get()
                .then((doc) => {
                    var data = doc.data();
                    
                    if(data['images'].length === 4) {
                        this.setState({maxImages: true});
                    }

                    this.setState({ 
                        date: moment(data['date'], 'MM/DD/YYYY'),
                        name: data['name'],
                        kids: data['kids'],
                        description: data['description'],
                        location: data['location'],
                        state: data['state'],
                        street: data['street'],
                        zipCode: data['zipCode'],
                        city: data['city'],
                        loading: false,
                        id: id,
                        images: data['images'],
                    });
                });
        };
    }
    
    onSave = () => {
        this.saveEventData();
        this.setState({ mode: true });
    }
    
    onSaveComplete = () => {
        this.saveEventData();
        this.setState({ messageSection: true })
    }

    saveEventData() {
        if (!this.state.saving) {
            if (this.state.name === '' || this.state.location === '' || this.state.state === '' || this.state.description === ''
                || this.state.zipCode === '' || this.state.city === '') {
                /* Push.create("KBAAZ", {
                    body: "Please fillout all fields!!!",
                    logo: './k-logo.png',
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    }); */
                toast.warn('Please fill out all fields!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });

            } else {
                this.setState({ saving: true });
                const eventData = {
                    name: this.state.name,
                    description: this.state.description,
                    date: this.state.date.format('MM/DD/YYYY'),
                    location: this.state.location,
                    state: this.state.state,
                    street: this.state.street,
                    zipCode: this.state.zipCode,
                    city: this.state.city,
                    refId: this.props.myId,
                    kids: this.state.kids,
                    images: this.state.images,
                    invite: false,
                    kidAdded: false,
                }

                if (!this.state.mode) {
                    eventsRef.add(eventData)
                        .then((ref) => {
                            /* Push.create("KBAAZ", {
                                body: "Event saved successfully",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                        window.focus();
                                        this.close();
                                    }
                                }); */
                            toast.success('Event saved successfully!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });
                            this.setState({ saving: false });
                            this.setState({ id: ref.id });
                            /* this.setState({ redirect: true }); */
                        })
                        .catch(() => {
                            /* Push.create("KBAAZ", {
                                body: "Error occurred",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                }
                            }); */
                            toast.error('Some error occurred!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });
                            this.setState({ saving: false });
                        });
                } else {
                    eventsRef.doc(this.state.id).set(eventData)
                        .then(() => {
                            /* Push.create("KBAAZ", {
                                body: "Event saved successfully",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                }
                            }); */
                            toast.success('Event saved successfully!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });
                            this.setState({ saving: false });
                            this.setState({ saved: true })
                        })
                        .catch(() => {
                            /* Push.create("KBAAZ", {
                                body: "Error occurred",
                                logo: './k-logo.png',
                                timeout: 4000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                }
                            }); */
                            toast.warn('Some error occurred!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });
                            this.setState({ saving: false });
                        });
                }
            }
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleDateChange = (date) => {
        this.setState({ date: date });
    }

    onDrop(picture) {
        this.setState({
            pictures: this.state.pictures.concat(picture),
            open: false,
        });
    }

    handleKidSelect = value => () => {
        const { kids } = this.state;
        const currentIndex = kids.indexOf(value);
        const newChecked = [...kids];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            kids: newChecked,
        });
    }

    handleContactSelect = value => () => {
        const { contacts } = this.state;
        const currentIndex = contacts.indexOf(value);
        const newChecked = [...contacts];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            contacts: newChecked,
        });
    }

    handleImageDelete = img => () => {
        imagesRef.child(img).delete()
        .then(() => {
            const { images, maxImages } = this.state;
            
            let updatedImages = images.filter(image => {
                return image.filename !== img;
            });

            if(maxImages) {
                this.setState({maxImages: false});
            }

            this.setState({ images: updatedImages });
        });
    }

    handleUploadSuccess = (filename) => {
        imagesRef.child(filename).getDownloadURL()
            .then(url => {
                const { images } = this.state;

                images.push({
                    'filename': filename,
                    'url': url,
                });

                var maxImages = false;

                if(images.length === 4) {
                    maxImages = true;
                }

                this.setState({ images: images, maxImages: maxImages });
            });
    };

    chooseGuest = () => {
        if(this.state.message === '' || this.state.subject === '') {
            toast.warn('Please fill out all fields!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            this.setState({ messageSection: false });
            this.setState({ chooseGuest: true });

            /* eventsRef.doc(this.state.id).set(messageData, {merge: true})
            .then(() => {
                toast.success('Message saved successfully!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                this.setState({ messageSection: false});
                this.setState({ chooseGuest: true });
            })
            .catch(() => {
                toast.error('Some error occurred!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }); */
        }
    }
    
    previewMessage = () => {
        var emails = [...this.state.contacts];
        var tmp = this.state.additionalGuest !== '' ? this.state.additionalGuest.split(','):[];
        tmp.forEach((email) => {
            emails.push(email.trim());
        });

        emails.forEach(email => {
            invitesRef.doc(this.state.id + '_' + email).set({
                email,
                eventId: this.state.id,
                amount: 0
            })
        });

        usersRef.where('email', '==', auth.currentUser.email).get().then((snapshots) => {
            snapshots.forEach((doc) => {
                var data = doc.data();
                this.setState({
                    name: data['firstName'] + ' ' + data['lastName'],
                    contacts: emails, showPreview: true, chooseGuest: false
                });
            });
        });

        /* eventsRef.doc(this.state.id).update({ 'contacts': emails })
        .then(() => {
            usersRef.where('email', '==', auth.currentUser.email).get().then((snapshots) => {
                snapshots.forEach((doc) => {
                    var data = doc.data();
                    this.setState({
                        name: data['firstName'] + ' ' + data['lastName'],
                        contacts: emails, showPreview: true, chooseGuest: false
                    });
                });
            });
        })
        .catch(() =>{ 
            toast.error('Some error occurred!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
         }); */
    }

    sendInvite = () => {
        eventsRef.doc(this.state.id).update({
                'invite': true, 
                'flag': false,
                'contacts':this.state.contacts,
                'message':this.state.message,
                'subject': this.state.subject,
                'kids': this.state.kids,
                'kidsAdded': false,
                'name': this.state.name
             })
        .then(() => {
            toast.success('Invitations are being sent!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            this.setState({redirect: true});
        })
        .catch(() => {
            toast.error('Some error occurred!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        });
    }   

    componentDidMount() {
        ValidatorForm.addValidationRule('isNameValid', (value) => {
            if (value.length > 20) {
                return false
            }
            return true;
        });

        ValidatorForm.addValidationRule('isZipValid', (value) => {
            if (value.match(/(^\d{5}$)|(^\d{5}-\d{4}$)/)) {
                return true;
            }
            return false;
        });
    }

    render() {

        const { classes } = this.props;

        if (this.state.redirect) {
            return (
                <Redirect to="/events" />
            );
        }

        if (this.state.loading || this.state.allContacts === null || this.state.allKids === null) {
            return (
                <h2>Loading...</h2>
            );
        }
     

        if (this.state.showPreview === true) {
            console.log('erer');
            return (

                <div className={classes.title}>
                    <Grid container spacing={40} style={{ paddingLeft: '20px', paddingBottom: '50px' }}>
                        <div className={classes.root}>
                         <img src='http://orioninfosolutions.org/rkbaaz/04.png' alt='wew'/>
      <AppBar position="static">
        <Toolbar>
         
          <Typography variant="title" color="inherit" className={classes.flex}>
           Message Preview
          </Typography>
          <Button variant="contained" onClick={this.sendInvite} color="secondary" className={classes.button}>
        Send
      </Button>
        </Toolbar>
      </AppBar>
      </div>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography gutterBottom={false} color="primary" variant="display1">Message Preview</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography gutterBottom={false} variant="headline">{this.state.subject}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography gutterBottom={false} variant="body2">Hi There</Typography>
                            <Typography gutterBottom={false} variant="body1">{this.state.message}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography gutterBottom={false} variant="caption">Sincerely,</Typography>
                            <Typography gutterBottom={false} variant="caption">{this.state.name}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography gutterBottom={false}>To attend this event clickhere</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.images.map(value => (
                                <Grid style={{ textAlign: 'center' }} item xs={12} sm={6} md={4} lg={3} xl={3}>
                                    <img style={{ height: '200px', width: '80%' }} alt="Remy Sharp" src={value.url} />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </div>
            );
        }

        if(this.state.messageSection === true) {
            console.log('wqewq');
            return(

                <div className={classes.title}>
                    <Grid container spacing={40} style={{ paddingLeft:'20px', paddingBottom: '50px' }}>
                      
                         <div className={classes.root}>
                          <img src='http://orioninfosolutions.org/rkbaaz/02.png' alt='wew'/>
      <AppBar position="static">
        <Toolbar>
         
          <Typography variant="title" color="inherit" className={classes.flex}>
           Invite Message
          </Typography>
          <Button variant="contained" color="secondary" onClick={this.chooseGuest} className={classes.button}>
        CHOOSE GUEST
      </Button>
        </Toolbar>
      </AppBar>
      </div>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField value={this.state.subject} onChange={this.handleChange('subject')} style={{ width: '80%' }} label={"Subject"} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField value={this.state.message} onChange={this.handleChange('message')} multiline rows='10' rowsMax="10" style={{ width: '80%' }} label={"Message"} />
                        </Grid>
                        
                    </Grid>
                </div>
            );
        }
        
        if(this.state.chooseGuest === true) {
            console.log('12');
            return(
                <div className={classes.title} style={{maxWidth:'100%' }}>
                    <Grid container spacing={40} style={{ paddingBottom: '50px', maxWidth:'100%' }}>
                        <Grid container item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <div className={classes.root}>
                             <img src='http://orioninfosolutions.org/rkbaaz/03.png' alt='wew'/>
      <AppBar position="static">
        <Toolbar>
         
          <Typography variant="title" color="inherit" className={classes.flex}>
         CHOOSE GUEST
          </Typography>
          <Button variant="contained" onClick={this.previewMessage} color="secondary" className={classes.button}>
        PREVIEW MESSAGE
      </Button>
        </Toolbar>
      </AppBar>
      </div>


                        <Grid className={classes.root} item xs={12} sm={12} md={12} lg={12} xl={12} style={{maxWidth:'100%' }}>
                            <PerfectScrollbar>
                                <div>
                                    <List>
                                        {this.state.allContacts.map(value => (
                                            <ListItem key={value.id} dense button className={classes.listItem}>
                                                <Avatar alt="Remy Sharp" src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light" />
                                                <ListItemText primary={value.name} />
                                                <ListItemText secondary={value.email} />
                                                <ListItemSecondaryAction>
                                                    <Checkbox
                                                        onChange={this.handleContactSelect(value.email)}
                                                        checked={this.state.contacts.indexOf(value.email) !== -1}
                                                        />
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </PerfectScrollbar>
                        </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField value={this.state.additionalGuest} onChange={this.handleChange('additionalGuest')}
                             style={{ width: '80%' }} label={"Add email address seperated by comma"} />
                        </Grid>
                        
                    </Grid>
                </div>
            )
        }

        console.log(this.state.images);
 console.log('weewewew');
        const imageSection = (
                this.state.images.map(value => (
                    <div  style={{ alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', textAlign:'center', width:'25%' }}>
                        <img style={{ height: '200px', width: '80%' }} alt="Remy Sharp" src={value.url} />
                        <Button onClick={this.handleImageDelete(value.filename)} variant='outlined'>DELETE</Button>
                    </div>
                ))
        )

        return (

            <div className={classes.title}>
                <ValidatorForm
                    ref="form"
                    onSubmit={this.onSaveComplete}
                >
                 <div className={classes.root}>
                  <img src='http://orioninfosolutions.org/rkbaaz/01.png' alt='wew'/>
      <AppBar position="static">

        <Toolbar>
        
          <Typography variant="title" color="inherit" className={classes.flex}>
           Event Details
          </Typography>
          <Button variant="contained" color="secondary" type='submit' className={classes.button}>
        SAVE & INVITE GUESTS
      </Button>
        </Toolbar>
      </AppBar>
      </div>

               
                <Grid container spacing={40} style={{ paddingBottom: '50px' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                       
                    </Grid>
                    <Grid item container spacing={40} xs={12} sm={6} md={6} lg={6} xl={6}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextValidator
                                style={{ width: '80%' }}
                                label="Event Name"
                                onChange={this.handleChange('name')}
                                name="name"
                                value={this.state.name}
                                validators={['required', 'isNameValid']}
                                errorMessages={['this field is required', 'must be less than 20 chars']}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <DatePicker
                                value={this.state.date}
                                onChange={this.handleDateChange}
                                style={{ width: '80%' }}
                                label="Event date"
                                format="MM/DD/YYYY"
                                placeholder="10/10/2018"
                                keyboard
                                mask={value => (value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : [])}
                                disableOpenOnEnter
                                animateYearScrolling={false}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <TextValidator
                                multiline
                                rowsMax={4}
                                style={{ width: '80%' }}
                                label="Description"
                                onChange={this.handleChange('description')}
                                name="description"
                                value={this.state.description}
                                validators={['required']}
                                errorMessages={['this field is required']}
                            />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography gutterBottom={false} color="primary" variant="display1">Event Location</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <TextValidator
                                style={{ width: '80%' }}
                                label="Location"
                                onChange={this.handleChange('location')}
                                name="location"
                                value={this.state.location}
                                validators={['required']}
                                errorMessages={['this field is required']}
                            />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <TextValidator
                                style={{ width: '80%' }}
                                label="State"
                                onChange={this.handleChange('state')}
                                name="state"
                                value={this.state.state}
                                validators={['required', 'isNameValid']}
                                errorMessages={['this field is required', 'must be less than 20 chars']}
                            />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <TextValidator
                                style={{ width: '80%' }}
                                label="Street"
                                onChange={this.handleChange('street')}
                                name="street"
                                value={this.state.street}
                                validators={['isNameValid']}
                                errorMessages={['must be less than 20 chars']}
                            />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <TextValidator
                            style={{ width: '80%' }}
                            label="Zip Code"
                            onChange={this.handleChange('zipCode')}
                            name="zipcode"
                            value={this.state.zipCode}
                            validators={['required', 'isZipValid']}
                            errorMessages={['this field is required', 'enter a valid zip code']}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <TextValidator
                                style={{ width: '80%' }}
                                label="City"
                                onChange={this.handleChange('city')}
                                name="city"
                                value={this.state.city}
                                validators={['required', 'isNameValid']}
                                errorMessages={['this field is required', 'must be less than 20 chars']}
                            />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    </Grid>

                    <Grid container item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography gutterBottom={false} color="primary" variant="subheading">Selcet Children</Typography>
                        </Grid>

                        <Grid className={classes.root} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <PerfectScrollbar>
                                <div>
                                    <List>
                                        {this.state.allKids.map(value => (
                                            <ListItem key={value.id} dense button className={classes.listItem}>
                                                <Avatar alt="Remy Sharp" src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light" />
                                                <ListItemText primary={value.name} secondary={value.accountId} />
                                                <ListItemSecondaryAction>
                                                    <Checkbox
                                                        onChange={this.handleKidSelect(value.id)}
                                                        checked={this.state.kids.indexOf(value.id) !== -1}
                                                    />
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </PerfectScrollbar>
                        </Grid>
                    </Grid>

                    <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography gutterBottom={false} color="primary" variant="subheading">Selcet Images</Typography>
                    <div style={{ alignContent: 'center', alignItems: 'center', justifyContent:'center', display: 'flex', flexDirection: 'row' }}>
                        {imageSection}

                    </div>
                        {!this.state.maxImages &&
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FileUploader
                                    multiple
                                    accept="image/*"
                                    randomizeFilename
                                    storageRef={imagesRef}
                                    style={{ paddingTop: '20px' }}
                                    onUploadSuccess={this.handleUploadSuccess}
                                />
                            </Grid>
                        }
                    </Grid>
                </Grid>
                </ValidatorForm>
            </div>
        );
    }
}

AddEvent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddEvent);


// WEBPACK FOOTER //
// ./src/components/Events/AddEvent.js